@if (item) {
  <div class="basket-item-container">
    <div style="display: flex;  width: 100%; align-items: center;">
      @if (!tenant.SuppressProductImages && !isMobile && showImages) {
        <div class="basket-item-image-container">
          <img class="basket-item-image" draggable="false" [src]="item.imageUrl">
        </div>
      }

      <div class="basket-item-details">
        <h4>{{ item.name }}</h4>
        <h4>{{ item.options }}</h4>

        @if (item.modifiers) {
          <div class="basket-item-details-row">
            <div class="basket-item-addons-group">
              @for (mod of item.modifiers.addons; track $index) {
                <div class="basket-item-addons-chip add-chip">
                  <mat-icon>add</mat-icon>
                  <span>{{ mod.quantity }}</span>
                  <span>{{ mod.name }}</span>
                </div>
              }

              @for (mod of item.modifiers.removes; track $index) {
                <div class="basket-item-addons-chip remove-chip">
                  <mat-icon>remove</mat-icon>
                  <span>{{ mod.name }}</span>
                </div>
              }
            </div>
          </div>
        }
        @if (basketIsModifiable) {
          <button mat-flat-button class="basket-item-quantity-remove-item" (click)="removeItem(item.id)">
            <mat-icon>close</mat-icon>
            Remove
          </button>
        }
      </div>

      <div style="display: flex; flex-direction: column; align-items: end;">
        @if (basketIsModifiable) {
          <app-quantity [value]="item.quantity"
                        [min]="1"
                        (add)="increaseQuantity(item)"
                        (minus)="decreaseQuantity(item)"
                        [useOutline]="true"></app-quantity>
        } @else {
          <span class="basket-item-price">x {{ item.quantity }}</span>
        }
        <span class="basket-item-price">£{{ item.price | StringToMoneyFilter }}</span>
      </div>
    </div>

    @if (item.issues.length) {
      @for (issue of getUniqueItemIssues(item.issues); track issue) {
        <p class="red-alert-text">{{ issue.Narrative }}</p>
      }
    }
  </div>
}
